import { MenuState } from 'state/menu';
import { CategoryAttributes, ProductAttributesFromCategories } from 'services/menu/menu.type';

export const computeCategories = (
    menu: MenuState,
    isProductDisplayedWhenUnavailable?: boolean,
): CategoryAttributes[] => {
    if (!menu?.categories) {
        return [];
    }

    const parentCategories = Object.values(menu.categories)
        .filter(({ parentCategoryId, webAvailability }) => webAvailability && !parentCategoryId)
        .sort(({ position: positionA }, { position: positionB }) => positionA - positionB);

    return parentCategories.flatMap((parentCategory) => {
        if (
            checkIfCategoryHasAvailableProducts(
                Object.values(parentCategory.products),
                isProductDisplayedWhenUnavailable,
            )
        ) {
            return parentCategory;
        }

        return Object.values(menu.categories)
            .filter(
                ({ parentCategoryId, webAvailability, products }) =>
                    webAvailability &&
                    checkIfCategoryHasAvailableProducts(
                        Object.values(products),
                        isProductDisplayedWhenUnavailable,
                    ) &&
                    parentCategoryId === parentCategory.categoryId,
            )
            .sort(({ position: positionA }, { position: positionB }) => positionA - positionB);
    });
};

export const checkIfCategoryHasAvailableProducts = (
    products: ProductAttributesFromCategories[],
    isProductDisplayedWhenUnavailable?: boolean,
): boolean => {
    if (!products.length) {
        return false;
    }

    return products.some(({ webAvailability, currentQuantity }) =>
        isProductDisplayedWhenUnavailable
            ? !!webAvailability
            : !!webAvailability && currentQuantity !== 0,
    );
};
